<script>
  import { RolesRepository } from "../repositories/index"
  import { isValidNameWithoutSpace, isValidDescription } from "../utils/validators"
  import { createEventDispatcher, onMount } from "svelte"
  import { ModalType } from "../types/modal"
  const dispatch = createEventDispatcher()
  import { Button, Form, TextField, Submit, Flex, FlexItem, Modal } from "@gl/design-system"
  import { _ } from "../stores/index"

  export let active
  export let data
  export let modalType

  let loading
  let form = {}

  async function onSubmit() {
    try {
      loading = true
      if (modalType === ModalType.Put) {
        await RolesRepository.editRole(data.id, { description: form.description })
      } else {
        const finalObj = {
          name: form.name,
        }
        if (form.description) finalObj.description = form.description
        await RolesRepository.addRole(finalObj)
      }

      dispatch("success")
    } finally {
      loading = false
    }
  }

  onMount(() => {
    if (modalType === ModalType.Put) {
      form.name = data.name
      form.description = data.description
    }
  })
</script>

<Modal bind:active on:close boxed>
  <div class="gl-title mb-4">
    {modalType === ModalType.Put ? $_("roles.edit_role") : $_("roles.add_role")}
  </div>
  <Form validationMode="eager">
    <TextField
      bind:value={form.name}
      id="role-name"
      label={$_("common.name")}
      required={$_("validations.required")}
      disabled={modalType === ModalType.Put}
      validate={(value) => isValidNameWithoutSpace(value)}
      maxLength={35}
      config={{ characterCount: $_("character.count") }}
    />
    <TextField
      bind:value={form.description}
      id="group-description"
      label={$_("common.description")}
      validate={(value) => isValidDescription(value)}
      maxLength={150}
      config={{ characterCount: $_("character.count") }}
    />
    <Flex>
      <FlexItem>
        <Submit {loading} on:submit={onSubmit} label={$_("buttons.save")} />
      </FlexItem>
      <FlexItem class="ml-4">
        <Button outlined on:click={() => dispatch("close")}>
          {$_("buttons.cancel")}
        </Button>
      </FlexItem>
    </Flex>
  </Form>
</Modal>
